export * from "./tabs.component";
